import { render, staticRenderFns } from "./RulePreview.vue?vue&type=template&id=4b8e6e6c&scoped=true"
import script from "./RulePreview.vue?vue&type=script&lang=js"
export * from "./RulePreview.vue?vue&type=script&lang=js"
import style0 from "./RulePreview.vue?vue&type=style&index=0&id=4b8e6e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8e6e6c",
  null
  
)

export default component.exports